// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"41":"error","620":"collections","767":"details","874":"men"}[chunkId] || chunkId) + "." + {"41":"10266cf1","414":"ea1d678a","620":"80d3eb98","767":"f7c8d7c7","874":"33962426"}[chunkId] + ".js";
};